
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class FadeOverlay extends Vue {
    @Prop({ type: Boolean, default: false }) readonly shown!: boolean;
  }
